import { initVueAppOnLoad } from '@/app'
import App from '@/views/Home.vue'
import Flash from '@/modules/Home/flash.js'

initVueAppOnLoad('#home', App, () => {
  new Flash()
})
